export * from './app-footer.component';



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-footer/index.ts